import { request } from "./request"

export interface IAssetLink {
  id: string
  type: 'link'
  linked_node_id: string
  parent_id: string
  name: string
}

export const assetsApi = {
  createSymlink: async (userID: string, params: Partial<IAssetLink>) => {
    const rsp = await assetsApi.getAssetsIds(userID, 1)
    const {
      ids: [assetId],
    } = rsp

    const data = {
      ...params,
      id: assetId,
      type: 'link',
    }
    return request('POST', `/api/2/users/${userID}/fs/root/nodes/`, data)
  },

  getAssetsIds: async (userID: string, count: number): Promise<{ids:string[]}> => {
    return request('POST', `/api/2/users/${userID}/fs/root/ids/`, { count })
  },

  getAssetInfo: async (userID: number, assetID: string, signal?: AbortSignal, params?: any): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fs/root/nodes/${assetID}`, params, { signal })
  },

  getSystemFields: async (userID: number, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fields/system`, undefined, { signal })
  },

  setFieldOnAsset: async (userID: number, assetID: string, fieldID: string, value: string[] | string, signal?: AbortSignal): Promise<any> => {
    return request('PUT', `/api/2/users/${userID}/fs/root/nodes/${assetID}/fields/${fieldID}`, { value }, { signal })
  },

  deleteAssetFields: async (userID: number, assetID: string, fieldID: string, signal?: AbortSignal): Promise<any> => {
    return request('DELETE', `/api/2/users/${userID}/fs/root/nodes/${assetID}/fields/${fieldID}`, undefined, { signal })
  },

  getAssetFields: async (userID: number, assetID: string, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fs/root/nodes/${assetID}/fields`, undefined, { signal })
  },

  updateField: async (userID: number, fieldID: string, data: { options?: any[], title?: string, description?: string }, signal?: AbortSignal): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fields/custom/${fieldID}/`, data, { signal })
  },

  updateSystemField: async (userID: number, fieldID: string, data: { options?: any[], title?: string, description?: string }, signal?: AbortSignal): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fields/system/${fieldID}/`, data, { signal })
  },

  updateAsset: (userId, nodeId, data) => {
    return request('PATCH',`/api/3/users/${userId}/fs/root/nodes/${nodeId}/`, data)
  },

  uploadNewFileVersionFromExistedFile: async (userID: number, nodeId: string, data: { file_source: string }, signal?: AbortSignal): Promise<any> => {
    return request('POST', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/versions/`, data, { signal })
  },
}
